module.exports = __webpack_public_path__ + "static/media/card.6e2e091f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/GetAShareResources/card.svg
// module id = 182
// module chunks = 0